module.exports = __webpack_public_path__ + "img/icon_modify_hover.676b0324.svg";